import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=61412244&"
import script from "./Acciones.vue?vue&type=script&lang=js&"
export * from "./Acciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports